import { render, staticRenderFns } from "./StyleCardHorizontal.vue?vue&type=template&id=6d8ecb26"
import script from "./StyleCardHorizontal.vue?vue&type=script&lang=js"
export * from "./StyleCardHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8ecb26')) {
      api.createRecord('6d8ecb26', component.options)
    } else {
      api.reload('6d8ecb26', component.options)
    }
    module.hot.accept("./StyleCardHorizontal.vue?vue&type=template&id=6d8ecb26", function () {
      api.rerender('6d8ecb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/StyleCard/StyleCardHorizontal.vue"
export default component.exports